module.exports = __webpack_public_path__ + "static/media/on-demand-body.6ceaa79f.svg";